import React from 'react';

interface ChartInfoBoxProps {
  description: string;
}

const ChartInfoBox: React.FC<ChartInfoBoxProps> = ({ description }) => {
  return (
    <div className="w-full self-start rounded-lg border border-gray-300 bg-white p-4 shadow-md md:w-1/4">
      <p
        className="text-gray-700"
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </div>
  );
};

export default ChartInfoBox;
